import {setLocalItem} from "utils/utils"


const CACHE_PREFIX = 'shift-rescues:'

export function getCachedAreaData(area, date) {
    try {
        const raw = localStorage.getItem(`${CACHE_PREFIX}${area}:${date}`)
        return raw ? JSON.parse(raw) : undefined
    } catch { return undefined }
}


/**
 * Shared react-query definition for daily_get_data (area/date), so that all
 * components showing the same area and date share one request and cache entry
 */
export function areaDataQuery(auth, API, area, date) {
    return {
        queryKey: ["area-data", area, date],
        queryFn: () => auth(API.reportsAreaDataDateGet, {area, date}).then(r => r.data).then(data => {
            setLocalItem(`${CACHE_PREFIX}${area}:${date}`, data)
            return data
        })
    }
}
